import { Link, useLocation } from 'react-router-dom'
import { loadDraft } from '@/lib/draft'

/**
 * Field landing screen.
 *
 * Two things a supervisor does from here: start a crew day, or record per diem
 * for a day nobody worked. It used to also list all 325 open jobs and every
 * earnings code -- both from the build's early days, when this screen existed
 * to prove that reference data reached the device at all. Neither was ever
 * acted on here: a job is picked inside the crew day, and the work type picker
 * carries the codes. Removing them means this screen fetches NOTHING, so it
 * paints instantly on a phone with one bar.
 */
export function FieldHome() {
  const location = useLocation()

  const flash = (location.state as { flash?: string } | null)?.flash
  const draft = loadDraft()

  return (
    <div className="stack">
      {flash && <div className="alert alert-info">{flash}</div>}

      <div className="card">
        <h2>Record a crew day</h2>
        <p className="muted">
          Pick a job, add your crew, enter hours. Works without signal — the day
          is saved on this phone. Once you have signal, tap Submit crew day to
          send it; it does not send by itself.
        </p>
        {draft?.jobNo ? (
          <>
            <div className="alert alert-warn">
              Unfinished crew day for <strong className="mono">{draft.jobNo}</strong> on{' '}
              {draft.dateWorked} — {draft.crewKeys.length} crew.
            </div>
            <Link className="btn btn-block" to="/field/new">
              Continue crew day
            </Link>
          </>
        ) : (
          <Link className="btn btn-block" to="/field/new">
            Start crew day
          </Link>
        )}
        {/* Per diem is paid on days nobody works — the weekend a crew stays
            over rather than driving home. A crew day cannot record that
            without inventing hours, so it gets its own way in. Secondary
            styling: it is the rarer of the two, and two primary buttons would
            make the common one harder to find. */}
        <Link className="btn btn-secondary btn-block" to="/field/per-diem"
              style={{ marginTop: 8 }}>
          Per diem only
        </Link>
      </div>

    </div>
  )
}
